module.exports = __webpack_public_path__ + "static/media/SHIB.a0d026ca.svg";